"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = void 0;

var formatDate = function formatDate(dateStr) {
  var date = new Date(dateStr);
  return date.toLocaleString('de-DE', {
    dateStyle: 'medium',
    timeStyle: 'short'
  }).replace(/, /, ' - ');
};

exports.formatDate = formatDate;


//////////////////
// WEBPACK FOOTER
// ./client/lib/format-date.js
// module id = 89
// module chunks = 0